import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BarChart3, CalendarDays, Crown, MessageCircle, PackageOpen, Receipt, UsersRound, Wallet } from 'lucide-react';
import styles from './Bento.module.css';

/* small visuals inside tiles */
const BillVisual = () => (
    <div className={styles.vBill}>
        {[['Hair Spa', '₹1,200'], ['Gold 10% off', '−₹120'], ['O3+ Facial (package)', '₹0']].map(([a, b], i) => (
            <div key={a} className={`${styles.vRow} ${i === 1 ? styles.good : ''}`}><span>{a}</span><b>{b}</b></div>
        ))}
        <div className={styles.vTotal}><span>Net payable</span><b>₹1,080</b></div>
    </div>
);
const CalendarVisual = () => (
    <div className={styles.vCal}>
        {[['10:30', 'Riya', 'Hair Spa', 'p'], ['12:00', 'Aman', 'Haircut', 'g'], ['2:30', 'Neha', 'Bridal trial', 'k'], ['4:30', 'Riya', 'Facial', 'p']].map(([t, n, s, c]) => (
            <div key={t} className={styles.vSlot}>
                <time>{t}</time>
                <span className={`${styles.vBlock} ${styles[`c_${c}`]}`}><strong>{s}</strong><small>{n}</small></span>
            </div>
        ))}
    </div>
);
const PackageVisual = () => (
    <div className={styles.vPkg}>
        {[['O3+ Facial', 2, 3], ['Hair Spa', 1, 2], ['Manicure', 2, 2]].map(([n, left, total]) => (
            <div key={n} className={styles.vPkgRow}>
                <span>{n}</span>
                <span className={styles.vDots}>{Array.from({ length: total }).map((_, i) => <i key={i} className={i < total - left ? styles.used : ''} />)}</span>
                <b>{left}/{total}</b>
            </div>
        ))}
    </div>
);

const TILES = [
    { id: 'billing', size: 'wide', icon: Receipt, title: 'Smart billing', text: 'Services, products, memberships and packages on one bill. GST, split payments and khata handled for you.', visual: <BillVisual /> },
    { id: 'appointments', size: 'tall', icon: CalendarDays, title: 'Appointments', text: 'Every stylist\'s day side by side, with WhatsApp reminders.', visual: <CalendarVisual /> },
    { id: 'memberships', icon: Crown, title: 'Memberships', text: 'Prepaid cards and discount plans that bring money in advance.' },
    { id: 'packages', icon: PackageOpen, title: 'Packages', text: 'Sell once, then track every visit until it is used up.', visual: <PackageVisual /> },
    { id: 'clients', icon: Wallet, title: 'Clients and khata', text: 'Visits, spend, dues and advance for every client.' },
    { id: 'staff', icon: UsersRound, title: 'Staff and payroll', text: 'Attendance, incentives and fair credit per bill.' },
    { id: 'analytics', icon: BarChart3, title: 'Analytics', text: 'Live dashboard, GST report and daily summary.' },
    { id: 'marketing', icon: MessageCircle, title: 'WhatsApp marketing', text: 'Campaigns to the right clients, tracked to the click.' },
];

export default function Bento() {
    return (
        <div className={styles.grid}>
            {TILES.map((t, i) => {
                const Icon = t.icon;
                return (
                    <motion.div
                        key={t.id}
                        className={`${styles.tile} ${t.size ? styles[t.size] : ''}`}
                        initial={{ opacity: 0, y: 18 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.25 }}
                        transition={{ duration: 0.5, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <Link to={`/features#${t.id}`} className={styles.link} aria-label={`${t.title}: see details`}>
                            <span className={styles.icon}><Icon size={16} strokeWidth={2.2} /></span>
                            <h3>{t.title}</h3>
                            <p>{t.text}</p>
                            {t.visual && <div className={styles.visual}>{t.visual}</div>}
                        </Link>
                    </motion.div>
                );
            })}
        </div>
    );
}
